import { useEffect, useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../core/hooks/storeHooks';
import TopSection from './components/topSection/TopSection';
import Grid from './components/grid/Grid';
import { Box, useColorModeValue } from '@chakra-ui/react';
import {
  calculateSheetViewport,
  loadSheet,
} from './redux/sagas/views/viewsActions';
import Loader from './components/loader/Loader';
import { Size } from '../core/types/ui/size';
import { IPosition2d } from '../core/types/ui/position';
import { EntitySize, IRange } from './types';



interface SheetProps extends Size, IPosition2d {
  windowId: string;
  sheetId: string;
}
const SheetApp: React.FC<SheetProps> = ({
  sheetId,
  x,
  y,
  width,
  height,
  windowId,
}) => {

  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();
  const background = useColorModeValue('#f5f8fa', '#161718');

  // const isExist: boolean = useAppSelector(
  //   (state) => !!state.sheetsManager.entityIdToNameMap.sheetsIdToName[sheetId]
  // );

  const isExist: boolean = useAppSelector(
    (state) => !!state.sheetsManager.sheets[sheetId]
  );

  useEffect(() => {
    if (sheetId) {
      // TODO: Load Sheet from db
      if (!isExist) {
        dispatch(
          loadSheet({
            sheetId: sheetId,
            windowId,
          })
        );
      } else {
        setLoading(false);
      }
    }
  }, [sheetId, isExist]);

  //   TODO: If not exist show Skeleton

  return useMemo(() => {
    if (loading) return <Loader width={width} height={height} />;

    return (
      <Box position="relative" background={background}>
        <TopSection sheetId={sheetId} />

        <Grid sheetId={sheetId} width={width} height={height} x={x} y={y} />
      </Box>
    );
  }, [loading, background, sheetId, width, height, x, y]);
};

export default SheetApp;
